import axios from "axios";

export const create = (currentEntityTypeId, formData, callback) => {
  var promise = axios({
    method: 'POST',
    url: Routes.abstract_controldoc_form_templates_path(currentEntityTypeId, { format: "json" }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
};

export const update = (params, formData, callback) => {
  var promise = axios({
    method: 'PATCH',
    url: Routes.abstract_controldoc_form_template_path({ id: params.id, current_entity_type_id: params.currentEntityTypeId, format: "json", _options: true }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
};
